import { createAction } from 'typesafe-actions'

import { Id } from 'src/types'

import { AgencyPartnersActionTypes, ResponseDataRequests } from './types'
import { ScrollNumberProps } from 'antd/lib/badge'

type Options = {
  page?: ScrollNumberProps
}

export const getAgencyPartners = createAction(
  AgencyPartnersActionTypes.GET_AGENCY_PARTNERS,
  action =>
    (
      options = {
        page: 1
      } as Options
    ) =>
      action({ options })
)

export const getAgencyPartnersFailure = createAction(
  AgencyPartnersActionTypes.GET_AGENCY_PARTNERS_FAILURE,
  action => (message: string) => action({ message })
)

export const getAgencyPartnersSuccess = createAction(
  AgencyPartnersActionTypes.GET_AGENCY_PARTNERS_SUCCESS,
  action =>
    ({ agency_partners }: ResponseDataRequests) =>
      action({ agency_partners })
)

export const sendAgencyPartners = createAction(
  AgencyPartnersActionTypes.SEND_AGENCY_PARTNERS,
  action =>
    (agency_partner: {
      partner_id?: Id
      agency_partner_id?: Id
      description?: String
      active: Boolean
    }) =>
      action({ agency_partner })
)

export const sendAgencyPartnersFailure = createAction(
  AgencyPartnersActionTypes.SEND_AGENCY_PARTNERS_FAILURE,
  action => (message: string) => action({ message })
)

export const sendAgencyPartnersSuccess = createAction(
  AgencyPartnersActionTypes.SEND_AGENCY_PARTNERS_SUCCESS,
  action => () => action()
)
